<template>
  <LeistungenOverview page="katalog" />
</template>

<script>
import LeistungenOverview from './leistungen-overview.vue';

export default {
  components: {
    LeistungenOverview,
  },
};
</script>
